import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { Bandeira } from "../api/dto/bandeira";

@Injectable({
    providedIn: 'root',
})
export class BandeiraService{

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'bandeiras/';

    listar(): Observable<Bandeira[]> {
        return this.http.get<Bandeira[]>(this.url);
    }
}